import apiConfig from "@/config/apiConfig";
const rootPath = apiConfig.companyApi; //不带manage

//单位基本信息
export const enterpriseEngraveApply = {
  submit: rootPath + "/webVerifyEngrave/enterpriseEngraveApply/submit", // 新增编辑(post)
  queryCompanyName: rootPath + "/webVerifyEngrave/enterpriseEngraveApply/queryCompanyName", // 新增编辑(post)
  saveOrUpdate: rootPath + "/webVerifyEngrave/enterpriseEngraveApply/saveOrUpdate", // 分页数据(get)
  querySeal0: rootPath + "/webVerifyEngrave/enterpriseEngraveApply/queryFlowOrders", // 刻章刻制流转单模板(get)
  querySeal1: rootPath + "/webVerifyEngrave/enterpriseEngraveApply/querySealFilings", // 刻章备案登记表模板(get)
  querySeal2: rootPath + "/webVerifyEngrave/enterpriseEngraveApply/queryPowerAttorney", // 刻章委托书模板(get)
  pageList: rootPath + "/webVerifyEngrave/enterpriseEngraveApply/pageList", // 分页数据(get)
  queryData: rootPath + "/webVerifyEngrave/enterpriseEngraveApply/queryData", // 分页数据(get)
  detail: rootPath + "/webVerifyEngrave/enterpriseEngraveApply/detail", // 详情(del)
  remove: rootPath + "/webVerifyEngrave/enterpriseEngraveApply/remove/", // 批量删除(del)
}
